import React from 'react';
import extbanner from '../../assets/images/extbanner.jpeg';

const STATS = [
  { value: '+10', label: 'Años de experiencia' },
  { value: '100%', label: 'Producción nacional' },
  { value: '∞', label: 'Atención personalizada' },
];

function Banner() {
  return (
    <section id="nosotros" className="relative overflow-hidden bg-ink-50 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:px-10 lg:grid-cols-2 lg:gap-16">
        {/* Text */}
        <div className="order-2 lg:order-1">
          <p className="eyebrow">
            <span className="h-px w-10 bg-brand-500" />
            Acerca de nosotros
          </p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-tight text-ink md:text-5xl">
            Industria nacional con
            <span className="italic text-brand-600"> alma de diseño</span>
          </h2>
          <p className="mt-6 text-base font-light leading-relaxed text-ink-600">
            Con sede en Córdoba, Argentina, Fabrilum cuenta con más de 10 años de
            experiencia en diseño, fabricación y comercialización de artículos de
            iluminación. Enfocados en la calidad y las terminaciones, creamos
            productos duraderos y estéticos. Nos destacamos por nuestra atención
            personalizada y flexibilidad, adaptándonos a tus necesidades. Creemos
            en el futuro de la Argentina y seguimos apostando a la industria
            nacional, comprometidos con la excelencia en la producción de
            luminarias.
          </p>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-ink/10 pt-8">
            {STATS.map((s) => (
              <div key={s.label}>
                <dt className="font-display text-3xl font-semibold text-brand-600 md:text-4xl">
                  {s.value}
                </dt>
                <dd className="mt-1 text-xs font-light leading-snug text-ink-500">
                  {s.label}
                </dd>
              </div>
            ))}
          </dl>

          <a
            href="mailto:info@fabrilum.com.ar?Subject=Quiero ser cliente"
            className="btn-primary mt-10"
          >
            Quiero ser cliente
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        {/* Image */}
        <div className="order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -right-4 -top-4 hidden h-full w-full rounded-3xl border border-brand-300/40 md:block" />
            <div className="relative overflow-hidden rounded-3xl shadow-card">
              <img
                src={extbanner}
                alt="Fabricación de luminarias Fabrilum"
                className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
